/** `session_id` / `order_id` reach the page as `router.query.*` — the shim parses them off the search string. */
import { createFileRoute } from '@tanstack/react-router'

import PaymentSuccessPage from '@/features/dashboard/pages/payment-success'

export const Route = createFileRoute('/_shell/payment-success')({ component: PaymentSuccessPage })
